<template>
  <div>
    <p class="text-clamped" :class="textClasses" :style="textStyles">
      <slot></slot>
    </p>

    <span v-if="!isExpanded" data-test-id="show-all" @click="showAll">
      <slot name="show-all-trigger"></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'TextClamped',
  props: {
    maxRows: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    textClasses() {
      return {
        'text-clamped--expanded': this.isExpanded
      };
    },
    textStyles() {
      return {
        '--max-rows': this.maxRows
      };
    }
  },
  methods: {
    showAll() {
      this.isExpanded = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.text-clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--max-rows);
  line-clamp: var(--max-rows);
  overflow: hidden;
  text-overflow: ellipsis;

  &--expanded {
    -webkit-line-clamp: inherit;
    line-clamp: inherit;
  }
}
</style>
